var MapService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import Graphic from "@arcgis/core/Graphic";
import esriConfig from "@arcgis/core/config";
import { MapTools } from "./map.tools";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import { AppConfig } from "../../app.config";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import { Router } from "@angular/router";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import { AppRoutingConstants } from "../../app-routing.constants";
import { CreateApplicationRoutingConstants } from "../../application/create-application/create-application-routing.constants";
import * as urlUtils from "@arcgis/core/core/urlUtils";
import { AuthService } from "../../shared/services/auth/auth.service";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import TileLayer from "@arcgis/core/layers/TileLayer";
import { HttpClient } from "@angular/common/http";
import { ApiModuleMapConstants } from "../../shared/constants/api-constants/api-module-map.constants";
import { ApiProxyConstants } from "../../shared/constants/api-constants/api-proxy.constants";
import { UserInformationService } from "../../shared/services/user/user-information.service";
import { BehaviorSubject, map, Subject } from "rxjs";
import * as rxjsOperators from "rxjs/operators";
import ImageryLayer from "@arcgis/core/layers/ImageryLayer";
import ImageryTileLayer from "@arcgis/core/layers/ImageryTileLayer";
import VectorTileLayer from "@arcgis/core/layers/VectorTileLayer";
import WMTSLayer from "@arcgis/core/layers/WMTSLayer";
import WMSLayer from "@arcgis/core/layers/WMSLayer";
// import Query from "@arcgis/core/tasks/support/Query";
// Logger.js:5 [esri.tasks.support.Query] 🛑 DEPRECATED - Module: esri.tasks.support.Query
// Replacement: esri.rest.support.Query
// Version: 4.20
import Query from "@arcgis/core/rest/support/Query";
import { Location } from "@angular/common";
import { AppControllerService } from "../../app-controller.service";
import { RequestStatusService } from "../../shared/services/request-status/request-status.service";
import { MapServiceConstants } from "../../core/settings/components/map-services/map-service.constants";
import Extent from "@arcgis/core/geometry/Extent";
import { AlertType } from "../../shared/models/alert";
import * as identify from "@arcgis/core/rest/identify";
import LOD from "@arcgis/core/layers/support/LOD";
import LayerSearchSource from "@arcgis/core/widgets/Search/LayerSearchSource";
import { ModuleConfigService } from "../../shared/services/module-config/module-config.service";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
import { take } from "rxjs/operators";
import { ViewApplicationService } from "src/app/application/view-application/view-application.service";
import { SystemModuleSettingsService } from "src/app/shared/services/system-module-settings.service";
let MapService = class MapService {
    static { MapService_1 = this; }
    mapTools;
    http;
    moduleConfigService;
    router;
    authService;
    userInformationService;
    location;
    requestStatusService;
    appController;
    viewApplicationService;
    moduleSettingsService;
    // inner class used for internal map defaults if none are provided
    static MapDefaults = class {
        baseMap = AppConfig.settings.defaultBasemap;
        center = [23.273294, -33.946994];
        zoom = 10;
    };
    // TODO: Are the MapDefault settings going to be set up in the config?
    defaultQueryBuffer = 5;
    showPopups = true;
    actionBlockEnabled = false;
    actionPropertyEnabled = false;
    actionPropertyOwnerEnabled = false;
    actionGraveEnabled = false;
    actionPremisesEnabled = false;
    actionBayEnabled = false;
    actionPOIEnabled = false;
    actionStreetEnabled = false;
    actionAdvertisementEnabled = false;
    actionMndRegionEnabled = false;
    actionMndAreaEnabled = false;
    actionMndWPUEnabled = false;
    actionMndPlantationEnabled = false;
    actionMndCompartmentEnabled = false;
    userMaps;
    layersLoadedSubject = new Subject();
    $layersLoaded = this.layersLoadedSubject.asObservable();
    layerTokens = [];
    mapServiceUrl = ApiModuleMapConstants.URL;
    isSysAdmin = false;
    _mapDefaults;
    _mapView;
    layersLoading = 0;
    selectedPropertySubject = new Subject();
    $selectedProperty = this.selectedPropertySubject.asObservable();
    selectedPropertyOwnerSubject = new Subject();
    $selectedOwnerProperty = this.selectedPropertyOwnerSubject.asObservable();
    selectedGraveSubject = new Subject();
    $selectedGrave = this.selectedGraveSubject.asObservable();
    selectedBlockSubject = new Subject();
    $selectedBlock = this.selectedBlockSubject.asObservable();
    selectedPremisesSubject = new Subject();
    $selectedPremises = this.selectedPremisesSubject.asObservable();
    selectedBaySubject = new Subject();
    $selectedBaySubject = this.selectedBaySubject.asObservable();
    selectedPOISubject = new Subject();
    $selectedPOISubject = this.selectedPOISubject.asObservable();
    selectedStreetSubject = new Subject();
    $selectedStreetSubject = this.selectedStreetSubject.asObservable();
    selectedAdvertisementSubject = new Subject();
    $selectedAdvertisementSubject = this.selectedAdvertisementSubject.asObservable();
    selectedMndRegionSubject = new Subject();
    $selectedMndRegion = this.selectedMndRegionSubject.asObservable();
    selectedMndLayerSubject = new Subject();
    $selectedMndLayer = this.selectedMndLayerSubject.asObservable();
    selectedMndAreaSubject = new Subject();
    $selectedMndArea = this.selectedMndAreaSubject.asObservable();
    selectedMndWPUSubject = new Subject();
    $selectedMndWPU = this.selectedMndWPUSubject.asObservable();
    selectedMndPlantationSubject = new Subject();
    $selectedMndPlantation = this.selectedMndPlantationSubject.asObservable();
    selectedMndCompartmentSubject = new Subject();
    $selectedMndCompartment = this.selectedMndCompartmentSubject.asObservable();
    proceedMapLoading = new BehaviorSubject(false);
    $proceedMapLoading = this.proceedMapLoading.asObservable();
    applicationLayerConfigured = new BehaviorSubject(false);
    $applicationLayerConfigured = this.applicationLayerConfigured.asObservable();
    applicationLayer = new BehaviorSubject(null);
    $applicationLayer = this.applicationLayer.asObservable();
    selectionLayers = [];
    onSelectBlock;
    addBlock;
    fetchModuleDataSubscription;
    constructor(mapTools, http, moduleConfigService, router, authService, userInformationService, location, requestStatusService, appController, viewApplicationService, moduleSettingsService) {
        this.mapTools = mapTools;
        this.http = http;
        this.moduleConfigService = moduleConfigService;
        this.router = router;
        this.authService = authService;
        this.userInformationService = userInformationService;
        this.location = location;
        this.requestStatusService = requestStatusService;
        this.appController = appController;
        this.viewApplicationService = viewApplicationService;
        this.moduleSettingsService = moduleSettingsService;
        this._mapDefaults = new MapService_1.MapDefaults();
    }
    static drawGraphic(graphic, graphicsLayer) {
        graphicsLayer.add(graphic);
    }
    static addGraphicsLayer(mapView, layerReference) {
        if (mapView.map) {
            let graphicsLayer = null;
            if (layerReference !== null) {
                mapView.map.layers.forEach(item => {
                    // tslint:disable-next-line:triple-equals
                    if (item.type === "graphics" && item.id == layerReference && graphicsLayer === null) {
                        graphicsLayer = item;
                    }
                });
            }
            if (graphicsLayer === null) {
                graphicsLayer = new GraphicsLayer({
                    listMode: "hide", id: layerReference ? layerReference : "graphicsLayer"
                });
                mapView.map.add(graphicsLayer);
            }
            return graphicsLayer;
        }
    }
    static removeGraphicsLayer(mapView, layerReference) {
        if (mapView.map && mapView.map.layers.length > 0) {
            mapView.map.layers.forEach((layer) => {
                if (layer.type === "graphics" && layer.id === layerReference) {
                    mapView.map.layers.remove(layer);
                }
            });
        }
    }
    static getStartApplicationRoute() {
        const route = `${CreateApplicationRoutingConstants.CREATE_APPLICATION_ROUTE}\
     ${AppRoutingConstants.ROUTE_SEPERATOR}\
     ${CreateApplicationRoutingConstants.DETAILS_ROUTE}`;
        const emptySpaceRe = new RegExp(" ", "gi");
        return route.replace(emptySpaceRe, "");
    }
    setProceedMapLoading(proceed) {
        this.proceedMapLoading.next(proceed);
    }
    destroyMap() {
        this.actionPropertyEnabled = false;
        this.actionPropertyOwnerEnabled = false;
        this.actionGraveEnabled = false;
        this.actionBlockEnabled = false;
        this.actionPremisesEnabled = false;
        this.actionBayEnabled = false;
        this.actionPOIEnabled = false;
        this.actionStreetEnabled = false;
        this.actionAdvertisementEnabled = false;
        this.actionMndRegionEnabled = false;
        this.actionMndAreaEnabled = false;
        this.actionMndWPUEnabled = false;
        this.actionMndPlantationEnabled = false;
        this.actionMndCompartmentEnabled = false;
        this.userMaps = [];
        this.layerTokens = [];
        this._mapView = null;
        this.layersLoading = 0;
        this.mapTools.mapTools = [];
    }
    async displayMap(mapViewEl, mapDefaults = this._mapDefaults, moduleId) {
        if (!mapViewEl) {
            throw new Error("Map View element doesnt exist");
        }
        const mapView = this.getMapView(mapDefaults, moduleId);
        if (mapView) {
            mapView.container = mapViewEl.nativeElement;
        }
        await mapView.when(() => {
            this.userMaps = [];
            this.addActions();
        }, (error) => {
            this.appController.showConsoleMessage(error);
        });
        return mapView;
    }
    toggleBuffer(event) {
        this.mapTools.toggleBuffer(event);
    }
    checkApplicationLayerConfigured(moduleId) {
        const params = {
            $filter: `moduleId eq ${moduleId} or (moduleId eq null and organisationId eq ${this.userInformationService.getOrganisationId(moduleId)})`,
            $orderby: "mapOrder desc"
        };
        this.fetchModuleDataSubscription = this.http.get(this.mapServiceUrl, { params }).pipe(take(1))
            .subscribe((response) => {
            const foundAppLayer = response.value.find(a => a.selectionLayerType === MapServiceConstants.APPLICATION_LAYER);
            if (foundAppLayer) {
                this.applicationLayerConfigured.next(true);
            }
            else {
                this.applicationLayerConfigured.next(false);
            }
        });
    }
    fetchModuleData(moduleId, loadLayers = true) {
        if (loadLayers === true) {
            const params = {
                $filter: `moduleId eq ${moduleId} or (moduleId eq null and organisationId eq ${this.userInformationService.getOrganisationId(moduleId)})`,
                $orderby: "mapOrder desc"
            };
            this.fetchModuleDataSubscription = this.http.get(this.mapServiceUrl, { params }).pipe(take(1))
                .subscribe((response) => {
                this.userMaps = [];
                const loadedIds = [];
                const urls = [];
                const selectionLayers = [];
                this.selectionLayers = [];
                response.value.sort((a, b) => 0 - (a.mapOrder > b.mapOrder ? -1 : 1));
                for (const item of response.value) {
                    // module maps
                    const existingLayer = this._mapView.map.allLayers.find(x => x.title === item.name);
                    if (existingLayer == null && item.selectionLayerType !== "AFLA Portal Application" && item.selectionLayerType !== "Editable grave" && item.selectionLayerType.toLowerCase() !== "all applications" && item.selectionLayerType.toLowerCase() !== "teams") {
                        if (item.moduleId !== undefined && item.moduleId !== null) {
                            urls.push(item.url);
                            selectionLayers.push(item.selectionLayerType);
                            if (item.selectionLayerType !== undefined && item.selectionLayerType !== null) {
                                this.selectionLayers.push(item.selectionLayerType);
                            }
                            this.addProxyRule(item.url);
                            const addedLayer = this.addLayer(item.url, item.type, item.name, item.defaultVisibility, item.showPopups);
                            item.layer = addedLayer;
                            loadedIds.push(item.id);
                            this.userMaps.push(item);
                        }
                    }
                }
                for (const item of response.value) {
                    // organisation maps
                    if (loadedIds.indexOf(item.id) === -1 && item.selectionLayerType !== "AFLA Portal Application" && item.selectionLayerType.toLowerCase() !== "all applications" && item.selectionLayerType.toLowerCase() !== "teams") {
                        if ((item.moduleId === undefined || item.moduleId === null) && urls.indexOf(item.url) === -1 && urls.indexOf(item.url) === -1) {
                            if (item.selectionLayerType !== undefined && item.selectionLayerType !== null) {
                                if (this.selectionLayers.indexOf(item.selectionLayerType) >= 0) {
                                    continue;
                                }
                                this.selectionLayers.push(item.selectionLayerType);
                            }
                            urls.push(item.url);
                            this.addProxyRule(item.url);
                            const addedLayer = this.addLayer(item.url, item.type, item.name, item.defaultVisibility, item.showPopups);
                            item.layer = addedLayer;
                            this.userMaps.push(item);
                        }
                    }
                }
                const foundAppLayer = this.userMaps.find(a => a.selectionLayerType === MapServiceConstants.APPLICATION_LAYER);
                this.applicationLayer.next(foundAppLayer?.layer);
                if (this.userMaps.length === 0) {
                    this.requestStatusService.removeBusySpinner("LoadingEsriMap");
                    this.layersLoadedSubject.next(true);
                }
                // Get the secure layer tokens here so that we don't have to make another asynchronous call when we intercept the print task
                this.userMaps.forEach((layer) => {
                    const paramsIndex = layer.url.indexOf("/rest");
                    const paramsDomain = layer.url.slice(0, paramsIndex);
                    const mapIndex = AppConfig.settings.arcGIS.printServiceURL.indexOf("/rest");
                    const mapDomain = AppConfig.settings.arcGIS.printServiceURL.slice(0, mapIndex);
                    if (paramsDomain !== mapDomain) {
                        const tokenRequestParams = this.getTokenRequestParams(layer);
                        if (tokenRequestParams) {
                            const getLayerTokenHeaders = {
                                MapServiceId: tokenRequestParams.MapServiceId, Authorization: tokenRequestParams.authorization
                            };
                            const apiUrl = AppConfig.settings.api.server + "/api";
                            this.getLayerToken(`${apiUrl.replace(AppRoutingConstants.API_PREFIX, ApiProxyConstants.URL_LAYER_TOKEN)}?${layer.url}`, { headers: getLayerTokenHeaders }).pipe(take(1)).subscribe((token) => {
                                const layerToken = this.layerTokens.filter((l) => l.id === layer.id);
                                // Avoid duplicates
                                if (layerToken.length < 1) {
                                    this.layerTokens.push({
                                        layer, auth: token
                                    });
                                }
                            }, (error) => {
                                this.appController.showConsoleMessage(error);
                            });
                        }
                    }
                });
                this.checkIfMapsAreLoaded();
            });
        }
    }
    setProxySettings() {
        const apiUrl = AppConfig.settings.api.server + "/api";
        urlUtils.addProxyRule({
            urlPrefix: AppConfig.settings.arcGIS.servicesURL,
            proxyUrl: apiUrl.replace(AppRoutingConstants.API_PREFIX, ApiProxyConstants.URL)
        });
        this.urlInterceptor();
    }
    addGeometriesAsGraphics(geometries, mapView, layerReference, clearBeforeAdd, zoomToLayerGraphicExtent, customSymbol) {
        return this.addGraphics(this.transformGeometryToGraphic(geometries, customSymbol), mapView, layerReference, clearBeforeAdd, zoomToLayerGraphicExtent);
    }
    clearGraphics(mapView, layerReference) {
        const graphicsLayer = MapService_1.addGraphicsLayer(mapView, layerReference);
        if (graphicsLayer) {
            graphicsLayer.removeAll();
        }
    }
    removeGraphicLayer(mapView, layerReference, graphicUid) {
        const graphicsLayer = MapService_1.addGraphicsLayer(mapView, layerReference);
        if (graphicsLayer) {
            graphicsLayer.graphics.forEach(graphic => {
                if (graphic.get("uid") === graphicUid) {
                    graphicsLayer.remove(graphic);
                    return;
                }
            });
        }
    }
    removeGraphicsLayer(mapView, layerReference) {
        MapService_1.removeGraphicsLayer(mapView, layerReference);
    }
    // Required to get Esri Worker
    externalEsriLoader() {
        esriConfig.assetsPath = this.location.prepareExternalUrl("assets");
    }
    executeIdentifyTask(event, params, url, mapView) {
        if (this.showPopups === true) {
            let canShowPopups = false;
            this.userMaps.forEach(item => {
                if (item.url === url) {
                    canShowPopups = item.showPopups;
                }
            });
            if (canShowPopups) {
                params.geometry = event.mapPoint;
                params.mapExtent = mapView.extent;
                identify.identify(url, params).then((response) => {
                    const results = response.results;
                    return results.map((result) => {
                        const feature = result.feature;
                        const layerName = result.layerName;
                        feature.attributes.layerName = layerName;
                        const fields = [];
                        for (const [key, value] of Object.entries(feature.attributes)) {
                            fields.push({ fieldName: key, label: key });
                        }
                        feature.popupTemplate = {
                            title: layerName, content: [{
                                    type: "fields", fieldInfos: fields
                                }]
                        };
                        return feature;
                    });
                })
                    .then(response => {
                    if (response && this.showPopups === true) {
                        this.showPopup(event, response, mapView);
                    }
                });
            }
        }
    }
    queryMapFeatureByAttribute(layerName, filter) {
        const layers = [];
        this._mapView.map.allLayers.forEach((layer) => {
            if (layer.type === "feature" && layer.title.toLocaleLowerCase() === layerName.toLocaleLowerCase()) {
                layers.push(layer);
            }
        });
        const query = new Query();
        query.returnGeometry = true;
        query.outFields = ["*"];
        query.where = filter;
        layers.forEach((layer) => {
            layer.load().then((loadedLayer) => {
                loadedLayer.queryFeatures(query).then((results) => {
                    if (loadedLayer.title.toLocaleLowerCase() === layerName.toLocaleLowerCase()) {
                        const feature = results.features[0];
                        feature.attributes.layerName = layerName.toLocaleLowerCase();
                        this.selectedMndLayerSubject.next(feature);
                    }
                });
            });
        });
    }
    executeQueryTask(event, layer, layerName, mapView, url) {
        if (layer.popupEnabled) {
            let canShowPopups = false;
            let canShowPropertyAction = false;
            let canShowPropertyOwnerAction = false;
            let canShowGraveAction = false;
            let canShowBlockAction = false;
            let canShowPremisesAction = false;
            let canShowBayAction = false;
            let canShowPOIAction = false;
            let canShowStreetAction = false;
            let canShowAdvertisementAction = false;
            let canShowMndRegionAction = false;
            let canShowMndAreaAction = false;
            let canShowMndWPUAction = false;
            let canShowMndPlantationAction = false;
            let canShowMndCompartmentAction = false;
            this.userMaps.forEach(item => {
                if (item.url === url) {
                    canShowPopups = true;
                    if (item.selectionLayerType.toLowerCase() === "property" && this.actionPropertyEnabled) {
                        canShowPropertyAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "property owner" && this.actionPropertyOwnerEnabled) {
                        canShowPropertyOwnerAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "grave" && this.actionGraveEnabled) {
                        canShowGraveAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "block" && this.actionBlockEnabled) {
                        canShowBlockAction = true;
                        this.onSelectBlock();
                    }
                    if (item.selectionLayerType.toLowerCase() === "premises" && this.actionPremisesEnabled) {
                        canShowPremisesAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "bays" && this.actionBayEnabled) {
                        canShowBayAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "poi" && this.actionPOIEnabled) {
                        canShowPOIAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "street" && this.actionStreetEnabled) {
                        canShowStreetAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "advertisement" && this.actionAdvertisementEnabled) {
                        canShowAdvertisementAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "region" && this.actionMndRegionEnabled) {
                        canShowMndRegionAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "area" && this.actionMndAreaEnabled) {
                        canShowMndAreaAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "workplanunit" && this.actionMndWPUEnabled) {
                        canShowMndWPUAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "plantation" && this.actionMndPlantationEnabled) {
                        canShowMndPlantationAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "compartment" && this.actionMndCompartmentEnabled) {
                        canShowMndCompartmentAction = true;
                    }
                }
            });
            const geometry = event.mapPoint;
            const query = new Query();
            query.geometry = geometry;
            query.distance = this.getBufferByModule();
            query.units = "meters";
            query.returnGeometry = true;
            query.outFields = ["*"];
            query.where = "1=1";
            layer.load().then((loadedLayer) => {
                loadedLayer.queryFeatures(query).then((results) => {
                    const features = results.features;
                    return features.map((feature) => {
                        feature.attributes.layerName = layerName;
                        const fields = [];
                        for (const [key, value] of Object.entries(feature.attributes)) {
                            let alias = key;
                            results.fields.forEach(field => {
                                if (field.name === key) {
                                    alias = field.alias;
                                }
                            });
                            fields.push({ fieldName: key, label: alias });
                        }
                        const template = {
                            title: layerName, content: [{
                                    type: "fields", fieldInfos: fields
                                }], actions: []
                        };
                        if (canShowPropertyAction) {
                            const propertyAction = {
                                title: "Add property", id: "add-property", image: "assets/images/plus.png"
                            };
                            template.actions.push(propertyAction);
                        }
                        if (canShowPropertyOwnerAction) {
                            const propertyOwnerAction = {
                                title: "Add property owner", id: "add-property-owner", image: "assets/images/plus.png"
                            };
                            template.actions.push(propertyOwnerAction);
                        }
                        if (canShowGraveAction) {
                            const graveAction = {
                                title: "Add grave", id: "add-grave", image: "assets/images/plus.png"
                            };
                            template.actions.push(graveAction);
                        }
                        if (canShowBlockAction) {
                            const blockAction = {
                                title: "Add block", id: "add-block", image: "assets/images/plus.png"
                            };
                            template.actions.push(blockAction);
                        }
                        if (canShowPremisesAction) {
                            const premisesAction = {
                                title: "Select premises", id: "add-premises", image: "assets/images/plus.png"
                            };
                            template.actions.push(premisesAction);
                        }
                        if (canShowBayAction) {
                            const bayAction = {
                                title: "Select bay", id: "add-bay", image: "assets/images/plus.png"
                            };
                            template.actions.push(bayAction);
                        }
                        if (canShowPOIAction) {
                            const poiAction = {
                                title: "Select POI", id: "add-POI", image: "assets/images/plus.png"
                            };
                            template.actions.push(poiAction);
                        }
                        if (canShowStreetAction) {
                            const streetAction = {
                                title: "Select street", id: "add-street", image: "assets/images/plus.png"
                            };
                            template.actions.push(streetAction);
                        }
                        if (canShowAdvertisementAction) {
                            const advertisementAction = {
                                title: "Select advertisement",
                                id: "add-advertisement",
                                image: "assets/images/plus.png"
                            };
                            template.actions.push(advertisementAction);
                        }
                        if (canShowMndRegionAction) {
                            const mndRegionAction = {
                                title: "Select Region",
                                id: "add-region",
                                image: "assets/images/plus.png"
                            };
                            template.actions.push(mndRegionAction);
                        }
                        if (canShowMndAreaAction) {
                            const mndAreaAction = {
                                title: "Select Area",
                                id: "add-area",
                                image: "assets/images/plus.png"
                            };
                            template.actions.push(mndAreaAction);
                        }
                        if (canShowMndWPUAction) {
                            const mndWPUAction = {
                                title: "Select Work Plan Unit",
                                id: "add-wpu",
                                image: "assets/images/plus.png"
                            };
                            template.actions.push(mndWPUAction);
                        }
                        if (canShowMndPlantationAction) {
                            const mndPlantationAction = {
                                title: "Select Plantation",
                                id: "add-plantation",
                                image: "assets/images/plus.png"
                            };
                            template.actions.push(mndPlantationAction);
                        }
                        if (canShowMndCompartmentAction) {
                            const mndCompartmentAction = {
                                title: "Select Compartment",
                                id: "add-compartment",
                                image: "assets/images/plus.png"
                            };
                            template.actions.push(mndCompartmentAction);
                        }
                        feature.popupTemplate = template;
                        return feature;
                    });
                }).then((response) => {
                    if (response && layer.popupEnabled) {
                        this.showPopup(event, response, mapView);
                        // Move adding actions listeners to after to popup has been opened
                        this.addActions();
                    }
                });
            });
        }
    }
    subscribeToMapsLoaded(mapView) {
        this.addMapsInSearchComponent(mapView);
    }
    addActions() {
        reactiveUtils.on(() => this._mapView.popup, "trigger-action", (event) => {
            const selectedFeature = this._mapView.popup.selectedFeature;
            if (event.action.id === "add-property") {
                this.selectedPropertySubject.next(selectedFeature);
            }
            else if (event.action.id === "add-property-owner") {
                this.selectedPropertyOwnerSubject.next(selectedFeature);
            }
            else if (event.action.id === "add-grave") {
                this.selectedGraveSubject.next(selectedFeature);
            }
            else if (event.action.id === "add-block") {
                this.selectedBlockSubject.next(selectedFeature);
                this.addBlock(selectedFeature);
            }
            else if (event.action.id === "add-premises") {
                this.selectedPremisesSubject.next(selectedFeature);
            }
            else if (event.action.id === "add-bay") {
                this.selectedBaySubject.next(selectedFeature);
            }
            else if (event.action.id === "add-POI") {
                this.selectedPOISubject.next(selectedFeature);
            }
            else if (event.action.id === "add-street") {
                this.selectedStreetSubject.next(selectedFeature);
            }
            else if (event.action.id === "add-advertisement") {
                this.selectedAdvertisementSubject.next(selectedFeature);
            }
            else if (event.action.id === "add-region") {
                this.selectedMndLayerSubject.next(selectedFeature);
            }
            else if (event.action.id === "add-area") {
                this.selectedMndLayerSubject.next(selectedFeature);
            }
            else if (event.action.id === "add-wpu") {
                this.selectedMndLayerSubject.next(selectedFeature);
            }
            else if (event.action.id === "add-plantation") {
                this.selectedMndLayerSubject.next(selectedFeature);
            }
            else if (event.action.id === "add-compartment") {
                this.selectedMndLayerSubject.next(selectedFeature);
            }
        });
    }
    checkForSysAdmin(mapView) {
        this.userInformationService.$userInformationFetched.pipe(take(1)).subscribe((fetched) => {
            if (fetched) {
                this.isSysAdmin = this.userInformationService.isSysadminAdmin();
                this.mapTools.addExtent(mapView, this.isSysAdmin);
            }
        });
    }
    addProxyRule(url) {
        const index = url.indexOf("/rest");
        const domain = url.slice(0, index);
        const apiUrl = AppConfig.settings.api.server + "/api";
        urlUtils.addProxyRule({
            urlPrefix: domain, proxyUrl: apiUrl.replace(AppRoutingConstants.API_PREFIX, ApiProxyConstants.URL)
        });
    }
    addLayer(url, type, title, defaultVisibility, showPopup) {
        let layer = null;
        switch (type) {
            case "MapImageLayer": {
                this.layersLoading++;
                layer = new MapImageLayer({
                    url, title, visible: defaultVisibility
                });
                break;
            }
            case "TileLayer": {
                this.layersLoading++;
                layer = new TileLayer({
                    url, title, visible: defaultVisibility
                });
                break;
            }
            case "FeatureLayer": {
                this.layersLoading++;
                layer = new FeatureLayer({
                    url, title, visible: defaultVisibility, popupEnabled: showPopup
                });
                break;
            }
            case "ImageryLayer": {
                this.layersLoading++;
                layer = new ImageryLayer({
                    url, title, visible: defaultVisibility, popupEnabled: showPopup
                });
                break;
            }
            case "ImageryTileLayer": {
                this.layersLoading++;
                layer = new ImageryTileLayer({
                    url, title, visible: defaultVisibility, popupEnabled: showPopup
                });
                break;
            }
            case "VectorTileLayer": {
                this.layersLoading++;
                layer = new VectorTileLayer({
                    url, title, visible: defaultVisibility
                });
                break;
            }
            case "WMSLayer": {
                this.layersLoading++;
                layer = new WMSLayer({
                    url, title, visible: defaultVisibility
                });
                break;
            }
            case "WMTSLayer": {
                this.layersLoading++;
                layer = new WMTSLayer({
                    url, title, visible: defaultVisibility,
                });
                break;
            }
            default: {
                break;
            }
        }
        if (layer !== null && this._mapView && this._mapView.map) {
            // @ts-ignore
            layer.legendEnabled = true;
            this._mapView.map.add(layer);
            layer.on("layerview-create", event => {
                this.layerAdded(event);
            });
            layer.on("layerview-create-error", event => {
                this.layerAdded(event);
            });
        }
        return layer;
    }
    layerAdded(event) {
        this.layersLoading--;
        if (this.layersLoading === 0) {
            this.requestStatusService.removeBusySpinner("LoadingEsriMap");
            this.layersLoadedSubject.next(true);
        }
    }
    showPopup(event, response, mapView) {
        if (response.length > 0) {
            mapView.popup.dockOptions = {
                breakpoint: false,
                buttonEnabled: false,
                position: "bottom-left"
            };
            mapView.popup.open({
                features: response,
                location: event.mapPoint
            });
        }
    }
    transformGeometryToGraphic(geometries, customSymbol) {
        const graphics = [];
        geometries.forEach(item => {
            let symbol = {};
            if (item.type === "mesh") {
                symbol = AppConfig.settings.selectedGeometrySymbols.mesh;
            }
            else if (item.type === "point" || item.type === "multipoint") {
                symbol = AppConfig.settings.selectedGeometrySymbols.point;
            }
            else if (item.type === "polyline") {
                symbol = AppConfig.settings.selectedGeometrySymbols.polyline;
            }
            else {
                symbol = AppConfig.settings.selectedGeometrySymbols.polygon;
            }
            if (customSymbol) {
                symbol = customSymbol;
            }
            const graphic = new Graphic({ geometry: item, symbol });
            graphics.push(graphic);
        });
        return graphics;
    }
    addGraphics(graphics, mapView, layerReference, clearBeforeAdd, zoomToLayerGraphicExtent) {
        const graphicsLayer = MapService_1.addGraphicsLayer(mapView, layerReference);
        if (graphicsLayer) {
            if (clearBeforeAdd !== null && clearBeforeAdd === true) {
                graphicsLayer.removeAll();
            }
            if (graphics && graphics.length > 0 && mapView) {
                graphics.forEach(graphic => {
                    MapService_1.drawGraphic(graphic, graphicsLayer);
                });
            }
            if (zoomToLayerGraphicExtent !== null && zoomToLayerGraphicExtent === true) {
                mapView.goTo(graphicsLayer.graphics)
                    .then(result => {
                    this.appController.showConsoleMessage(result);
                    // mapView.goTo(mapView.extent.expand(1.2))
                    //   .then()
                    //   .catch((error) => {
                    //     // This function returns a promise which resolves as soon as the new view has been set to the target.
                    //     // If setting the view to the new target fails, the promise returned by the goTo() method rejects with an error. Use a catch statement, to handle the error
                    //     if (error.name !== "AbortError") {
                    //       console.error(error);
                    //     }
                    //   });
                })
                    .catch((error) => {
                    // This function returns a promise which resolves as soon as the new view has been set to the target.
                    // If setting the view to the n ew target fails, the promise returned by the goTo() method rejects with an error. Use a catch statement, to handle the error
                    if (error.name !== "AbortError") {
                        console.error(error);
                    }
                });
            }
            else {
                mapView.goTo(graphics)
                    .then(result => {
                    mapView.goTo(mapView.extent.expand(1.2))
                        .then()
                        .catch((error) => {
                        // This function returns a promise which resolves as soon as the new view has been set to the target.
                        // If setting the view to the new target fails, the promise returned by the goTo() method rejects with an error. Use a catch statement, to handle the error
                        if (error.name !== "AbortError") {
                            console.error(error);
                        }
                    });
                })
                    .catch((error) => {
                    // This function returns a promise which resolves as soon as the new view has been set to the target.
                    // If setting the view to the new target fails, the promise returned by the goTo() method rejects with an error. Use a catch statement, to handle the error
                    if (error.name !== "AbortError") {
                        console.error(error);
                    }
                });
            }
            // mapView.map.add(graphicsLayer);
        }
        return graphics;
    }
    createMapView(mapDefaults, moduleId) {
        const mapProperties = {
            basemap: mapDefaults.baseMap
        };
        const map = new Map(mapProperties);
        let mapViewProperties = {};
        const levelOfDetails = [];
        let lodIndex = 1;
        if (AppConfig.settings.defaultMapScales.length > 0) {
            AppConfig.settings.defaultMapScales.forEach((scale) => {
                if (scale.show.toLowerCase() === "true") {
                    const lod = new LOD({ level: lodIndex, levelValue: lodIndex.toString(), scale: scale.scale });
                    levelOfDetails.push(lod);
                    lodIndex++;
                }
            });
            mapViewProperties = {
                map, spatialReference: new SpatialReference({
                    wkid: 102100,
                }), constraints: {
                    lods: levelOfDetails
                }, center: mapDefaults.center, zoom: mapDefaults.zoom
            };
        }
        else {
            mapViewProperties = {
                map, spatialReference: new SpatialReference({
                    wkid: 102100,
                }), center: mapDefaults.center, zoom: mapDefaults.zoom
            };
        }
        const mapView = new MapView(mapViewProperties);
        mapView.ui.move("zoom", "bottom-right");
        this.moduleSettingsService.$systemModuleSettings.pipe(take(1)).subscribe(settings => {
            const defaultExtentSetting = settings.find(setting => setting.moduleId === moduleId && setting.key?.toLowerCase() === "defaultextent" && !!setting.value);
            if (defaultExtentSetting) {
                try {
                    const extent = new Extent(JSON.parse(defaultExtentSetting.value));
                    mapView.extent = extent;
                }
                catch (e) {
                    this.appController.showMessage("Module's default extent is incorrectly set. Please contact your system administrator.", AlertType.Success);
                }
            }
            if (!mapView.extent) {
                this.userInformationService.$systemOrganisations.pipe(take(1)).subscribe(() => {
                    const organisationId = this.userInformationService.getOrganisationId(moduleId);
                    const organisation = organisationId
                        ? this.userInformationService.getOrganisationInformation(organisationId)
                        : null;
                    const defaultExtent = organisation?.defaultExtent;
                    if (defaultExtent) {
                        try {
                            const extent = new Extent(JSON.parse(defaultExtent));
                            mapView.extent = extent;
                        }
                        catch (e) {
                            this.appController.showMessage("Organisation's default extent is incorrectly set. Please contact your system administrator.", AlertType.Success);
                        }
                    }
                });
            }
        });
        this.mapTools.mapTools = [];
        this.mapTools.addDraw(mapView);
        this.mapTools.addSearch(mapView);
        this.mapTools.addBaseMaps(mapView);
        this.mapTools.addPrint(mapView, moduleId);
        this.mapTools.addMeasure(mapView);
        this.mapTools.addLegend(mapView);
        this.mapTools.addLayerList(mapView);
        this.mapTools.addBookmark(mapView);
        this.mapTools.addHome(mapView);
        this.mapTools.addFullScreenWidget(mapView);
        reactiveUtils.when(() => mapView?.ready === true, () => {
            this.checkForSysAdmin(mapView);
        });
        return mapView;
    }
    urlInterceptor() {
        esriConfig.request.interceptors.push({
            before: (params) => {
                if (params.url.startsWith(AppConfig.settings.arcGIS.servicesURL)) {
                    let identityToken = "";
                    this.authService.$authenticationToken.pipe(take(1)).subscribe((tokenChange) => {
                        identityToken = tokenChange;
                    });
                    params.requestOptions.headers = params.requestOptions.headers || {};
                    params.requestOptions.headers.authorization = "Bearer " + identityToken;
                }
                // Intercept the print POST action to set the token of the secured layers that were not published onto the AGS of the Print Task
                if (params.url === `${AppConfig.settings.arcGIS.printServiceURL}/execute`) {
                    const webMapObj = JSON.parse(params.requestOptions.query.Web_Map_as_JSON);
                    let updatedWebMapObj = params.requestOptions.query.Web_Map_as_JSON;
                    webMapObj.operationalLayers.forEach((layer) => {
                        const paramsIndex = layer.url.indexOf("/rest");
                        const paramsDomain = layer.url.slice(0, paramsIndex);
                        const mapIndex = AppConfig.settings.arcGIS.printServiceURL.indexOf("/rest");
                        const mapDomain = AppConfig.settings.arcGIS.printServiceURL.slice(0, mapIndex);
                        if (paramsDomain !== mapDomain) {
                            const legendLayer = webMapObj.layoutOptions.legendOptions.operationalLayers.filter((l) => l.id === layer.id);
                            if (legendLayer.length > 0 && (legendLayer[0].id === layer.id)) {
                                this.layerTokens.forEach((lt) => {
                                    if (layer.url.includes(lt.layer.url)) {
                                        layer.url = `${layer.url}?token=${lt.auth}`;
                                        updatedWebMapObj = JSON.stringify(webMapObj);
                                    }
                                });
                            }
                        }
                    });
                    delete params.requestOptions.query.Web_Map_as_JSON;
                    params.requestOptions.query.Web_Map_as_JSON = updatedWebMapObj;
                }
                if (this.userMaps) {
                    for (const map of this.userMaps) {
                        let identityToken = "";
                        this.authService.$authenticationToken.pipe(take(1)).subscribe((tokenChange) => {
                            identityToken = tokenChange;
                        });
                        params.requestOptions.headers = params.requestOptions.headers || {};
                        const paramsIndex = params.url.indexOf("/rest");
                        const paramsDomain = params.url.slice(0, paramsIndex);
                        const mapIndex = map.url.indexOf("/rest");
                        const mapDomain = map.url.slice(0, mapIndex);
                        if (paramsDomain === mapDomain) {
                            params.requestOptions.headers.authorization = `Bearer ${identityToken}`;
                            params.requestOptions.headers.MapServiceId = `${map.id}`;
                        }
                    }
                }
            }, after: (response) => {
                if (response.url === AppConfig.settings.arcGIS.printServiceURL + "/execute") {
                    // This prevents the link from opening on a new browser tab through the proxy. No need to be authenticated when opening the print
                    response.data.results.forEach((result) => {
                        Array.from(document.getElementsByClassName("esri-print__exported-file-link")).forEach((link) => {
                            link.addEventListener("click", (e) => {
                                if (!e.defaultPrevented) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    window.open(result.value.url, "_blank");
                                }
                            });
                        });
                    });
                }
            }
        });
    }
    getMapView(mapDefaults, moduleId) {
        this._mapView = this.createMapView(mapDefaults, moduleId);
        // this.addPropertyLayer(this._mapView);
        return this._mapView;
    }
    getTokenRequestParams(layer) {
        for (const map of this.userMaps) {
            if (layer.url.includes(map.url)) {
                let identityToken = "";
                this.authService.$authenticationToken.pipe(take(1)).subscribe((tokenChange) => {
                    identityToken = tokenChange;
                });
                const tokenRequestParams = {
                    authorization: `Bearer ${identityToken}`, MapServiceId: `${map.id}`
                };
                return tokenRequestParams;
            }
        }
    }
    getLayerToken(endPointUrl, params) {
        return this.http.get(endPointUrl, params)
            .pipe(rxjsOperators.map(response => {
            return response;
        }));
    }
    // check if maps are available
    checkIfMapsAreLoaded() {
        if (this.userMaps.length > 0 && this._mapView && this._mapView.map) {
            this.subscribeToMapsLoaded(this._mapView);
        }
    }
    // adds the maps into the search widget
    addMapsInSearchComponent(mapView) {
        const searchWidget = mapView.ui.find("searchWidget");
        mapView.map.layers.forEach((layer) => {
            if (layer.type === "feature" && this.isSelectionLayer(layer)) {
                const l = layer;
                l.load().then((loadedMapLayer) => {
                    const source = this.prepareSearchSource(loadedMapLayer);
                    searchWidget.sources.push(source);
                    searchWidget.sources.sort((a, b) => a.name.localeCompare(b.name));
                });
            }
        });
    }
    // This function builds and returns a LayerSearchSource for a given layer
    prepareSearchSource(loadedMapLayer) {
        const forbiddenFields = [
            "shape",
            "startdate",
            "endDate",
            "registered",
            "OBJECTID",
            "SgCode",
            "PtnNum ",
            "Shape_Length",
            "Shape_Area",
            "PremiseID",
            "SgCodeExternal",
            "Registered",
            "SgDiagramNo",
            "ErfSize",
            "HasGeometry",
            "Allotment",
            "IDNumber",
            "Property_OBJECTID",
            "ModuleID",
            "GlobalID",
            "CemeteryID"
        ].map(field => field.toLowerCase());
        const fields = loadedMapLayer.fields
            .filter((field) => !forbiddenFields.includes(field.name.toLowerCase().trim()) && (field.type !== "small-integer" && field.type !== "date" && field.type !== "geometry"))
            .map(field => field.name);
        const suggestionTemplate = fields?.map((field, index) => `<span><strong>${fields[index]}:</strong> {${field}}</span> <br>`).join("");
        return new LayerSearchSource({
            layer: loadedMapLayer,
            searchFields: fields,
            suggestionTemplate,
            exactMatch: false,
            placeholder: `Search ${loadedMapLayer.title}`,
            outFields: ["*"],
            name: loadedMapLayer.title,
            withinViewEnabled: false,
            suggestionsEnabled: true,
            maxSuggestions: 50,
            minSuggestCharacters: 1,
        });
    }
    // This function checks whether a layer is a selection layer
    isSelectionLayer(selectedLayer) {
        let isSelectionLayer = false;
        for (const userMap of this.userMaps) {
            if (userMap.layer.id === selectedLayer.id && userMap.selectionLayerType.toLowerCase() !== "application") {
                isSelectionLayer = true;
                break;
            }
        }
        return isSelectionLayer;
    }
    getBufferByModule() {
        let defaultQueryBuffer = 0;
        if (this.moduleConfigService.isStreetNamingModule()) {
            defaultQueryBuffer = 15;
        }
        return defaultQueryBuffer;
    }
    getAuthenticatedMapServiceUrl(url) {
        this.addProxyRule(url);
        this.urlInterceptor();
        return url;
    }
    getLayerDataBySelectionLayerType(moduleId, selectionLayerType) {
        const params = {
            $filter: `moduleId eq null and organisationId eq ${this.userInformationService.getOrganisationId(moduleId)} and selectionLayerType eq '${selectionLayerType}' and deleted eq false`
        };
        return this.http.get(this.mapServiceUrl, { params }).pipe(map(response => response.value && response.value.length > 0 ? response.value[0] : null));
    }
    getLayerDataBySelectionLayerTypeModuleId(moduleId, selectionLayerType) {
        const params = {
            $filter: `moduleId eq ${moduleId} and organisationId eq ${this.userInformationService.getOrganisationId(moduleId)} and selectionLayerType eq '${selectionLayerType}' and deleted eq false`
        };
        return this.http.get(this.mapServiceUrl, { params }).pipe(map(response => response.value && response.value.length > 0 ? response.value[0] : null));
    }
    static ctorParameters = () => [
        { type: MapTools },
        { type: HttpClient },
        { type: ModuleConfigService },
        { type: Router },
        { type: AuthService },
        { type: UserInformationService },
        { type: Location },
        { type: RequestStatusService },
        { type: AppControllerService },
        { type: ViewApplicationService },
        { type: SystemModuleSettingsService }
    ];
};
MapService = MapService_1 = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsub()
], MapService);
export { MapService };
